import React, { useEffect, useState } from "react";
import "../../assets/css/layouts/floatingsocial.css";

import insta from "../../assets/img/instatoggle.svg";
import kakao from "../../assets/img/kakaotoggle.svg";
import up from "../../assets/img/uptoggle.svg";

import { publicApiClient } from "../../api/apiClient";

const CONTACT_API = "/api/contact/site";

const getContactData = (result) => {
  return result?.data || result || {};
};

export default function FloatingSocial() {
  const [open, setOpen] = useState(false);
  const [contact, setContact] = useState({
    kakaoUrl: "",
    instagramUrl: "",
  });

  useEffect(() => {
    const fetchContact = async () => {
      try {
        const result = await publicApiClient(CONTACT_API);
        const data = getContactData(result);

        setContact({
          kakaoUrl: data.kakaoUrl || "",
          instagramUrl: data.instagramUrl || "",
        });
      } catch (error) {
        console.error("플로팅 소셜 링크 조회 실패:", error);

        setContact({
          kakaoUrl: "",
          instagramUrl: "",
        });
      }
    };

    fetchContact();
  }, []);

  const hasSocialLink = contact.instagramUrl || contact.kakaoUrl;

  return (
    <div className={`fab ${open ? "is-open" : ""}`}>
      <button
        type="button"
        className="fab-toggle"
        aria-label={open ? "메뉴 닫기" : "메뉴 열기"}
        aria-expanded={open}
        onClick={() => setOpen((v) => !v)}
      >
        <img src={up} alt="" />
      </button>

      {hasSocialLink && (
        <div className="fab-list" aria-hidden={!open}>
          {/* 인스타그램 */}
          {contact.instagramUrl && (
            <a
              className="fab-item fab-insta"
              href={contact.instagramUrl}
              target="_blank"
              rel="noreferrer"
              aria-label="Instagram 계정 바로가기"
            >
              <img src={insta} alt="" />
            </a>
          )}

          {/* 카카오톡 */}
          {contact.kakaoUrl && (
            <a
              className="fab-item fab-kakao"
              href={contact.kakaoUrl}
              target="_blank"
              rel="noreferrer"
              aria-label="KakaoTalk 채널 바로가기"
            >
              <img src={kakao} alt="" />
            </a>
          )}
        </div>
      )}
    </div>
  );
}